import React, { Fragment, useEffect, useState } from "react"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import MagazineService from "../../../shared/services/magazine"
import FeaturedArticle from "../../atoms/featured-article/featured-article"
import FeaturedAutopauta from "../../atoms/featured-autopauta/featured-autopauta"
import SectionTypeArticle from "../section-type-article/section-type-article"
import "./section-card-articles-mg.scss"
import CardArticleMG from "../../atoms/card-article-mg/card-article-mg"
import { siteUrl } from "../../../shared/utils/siteUrl"

const SectionCardArticlesMG = props => {
  const { setModalState, categoryFilterTitleActive } = props

  const [localLikes, setlocalLikes] = useState([])
  const [isLog, setisLog] = useState(false)
  const [savedArticles, setsavedArticles] = useState([])

  const homeLink = siteUrl

  useEffect(() => {
    if (localStorage.getItem("TOKEN_INFO") === null) {
      if (localStorage.getItem("LOCAL_ARTICLES_LIKES") !== null) {
        setlocalLikes(JSON.parse(localStorage.getItem("LOCAL_ARTICLES_LIKES")))
      }
    } else {
      setisLog(true)

      if (localStorage.getItem("LOCAL_ARTICLES_LIKES") !== null) {
        localStorage.removeItem("LOCAL_ARTICLES_LIKES")
      }

      if (localStorage.getItem("SAVED_ARTICLES") !== null) {
        setsavedArticles(JSON.parse(localStorage.getItem("SAVED_ARTICLES")))
      }

      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }
      MagazineService.getLikesArticles(process.env.COUNTRY_CODE, config).then(
        res => {
          // console.log(res)

          if (res.status === 200) {
            localStorage.setItem(
              "LOCAL_ARTICLES_LIKES",
              JSON.stringify(res.data)
            )
            setlocalLikes(res.data)
          } else {
            console.log(res)
          }
        }
      )
    }
  }, [])

  const handleLike = idArticle => {
    var payload = {
      contentId: idArticle,
      country: process.env.COUNTRY_CODE,
      like: true,
    }

    if (localStorage.getItem("TOKEN_INFO") === null) {
      MagazineService.postLikeAnom(payload)
        .then(res => {
          if (res.status === 200) {
            if (localStorage.getItem("LOCAL_ARTICLES_LIKES") === null) {
              localStorage.setItem(
                "LOCAL_ARTICLES_LIKES",
                JSON.stringify([idArticle])
              )
              setlocalLikes([idArticle])
            } else {
              var copyLocalStorageLikes = JSON.parse(
                localStorage.getItem("LOCAL_ARTICLES_LIKES")
              )
              var newLikeList = copyLocalStorageLikes.concat([idArticle])
              localStorage.setItem(
                "LOCAL_ARTICLES_LIKES",
                JSON.stringify(newLikeList)
              )
              setlocalLikes(newLikeList)
            }
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    } else {
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }

      MagazineService.postLikeAuth(payload, config)
        .then(res => {
          if (res.status === 200) {
            if (localStorage.getItem("LOCAL_ARTICLES_LIKES") === null) {
              localStorage.setItem(
                "LOCAL_ARTICLES_LIKES",
                JSON.stringify([idArticle])
              )
              setlocalLikes([idArticle])
            } else {
              var copyLocalStorageLikes = JSON.parse(
                localStorage.getItem("LOCAL_ARTICLES_LIKES")
              )
              var newLikeList = copyLocalStorageLikes.concat([idArticle])
              localStorage.setItem(
                "LOCAL_ARTICLES_LIKES",
                JSON.stringify(newLikeList)
              )
              setlocalLikes(newLikeList)
            }
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    }
  }

  const handleUnLike = idArticle => {
    var payload = {
      contentId: idArticle,
      country: process.env.COUNTRY_CODE,
      like: false,
    }

    if (localStorage.getItem("TOKEN_INFO") === null) {
      MagazineService.postLikeAnom(payload)
        .then(res => {
          if (res.status === 200) {
            var copyLocalStorageLikes = JSON.parse(
              localStorage.getItem("LOCAL_ARTICLES_LIKES")
            )
            var newLikeList = copyLocalStorageLikes.filter(
              item => item !== idArticle
            )
            localStorage.setItem(
              "LOCAL_ARTICLES_LIKES",
              JSON.stringify(newLikeList)
            )
            setlocalLikes(newLikeList)
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    } else {
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      let config = {
        headers: {
          Authorization: tokenId,
        },
      }

      MagazineService.postLikeAuth(payload, config)
        .then(res => {
          if (res.status === 200) {
            var copyLocalStorageLikes = JSON.parse(
              localStorage.getItem("LOCAL_ARTICLES_LIKES")
            )
            var newLikeList = copyLocalStorageLikes.filter(
              item => item !== idArticle
            )
            localStorage.setItem(
              "LOCAL_ARTICLES_LIKES",
              JSON.stringify(newLikeList)
            )
            setlocalLikes(newLikeList)
          } else {
            console.log(res)
          }
        })
        .catch(e => console.log(e))
    }
  }

  const handleSave = (e, payload) => {
    e.preventDefault()

    if (isLog) {
      if (localStorage.getItem("SAVED_ARTICLES") === null) {
        localStorage.setItem("SAVED_ARTICLES", JSON.stringify([payload]))
        setsavedArticles([payload])
      } else {
        let copyList = savedArticles
        let newList = copyList.concat([payload])
        setsavedArticles(newList)
        localStorage.setItem("SAVED_ARTICLES", JSON.stringify(newList))
      }

      window.location.href = homeLink + payload.slug + "#saved"
    } else {
      setModalState()
    }
  }

  const handleUnSave = (e, id) => {
    e.preventDefault()

    let copyList = savedArticles
    let newList = copyList.filter(a => a.id !== id)
    setsavedArticles(newList)
    localStorage.setItem("SAVED_ARTICLES", JSON.stringify(newList))
  }

  return (
    <div className="f-sectioncardarticles">
      <div className="f-decorationbackground"></div>
      <div className="f-sectioncardarticles-articles">
        {props.activeCategory !== "articulos-usuarias" && (
          <SectionTypeArticle
            typesArticles={props.typesArticles}
            typeActive={props.typeActive}
            setTypeActive={props.setTypeActive}
          />
        )}
        {props.activeCategory === "articulos-usuarias" && (
          <div className="f-sectioncardarticles-articles-titletab">
            <TitleTab
              title={
                props.mobile
                  ? "Escrito por usuarias"
                  : "Escrito por nuestras usuarias"
              }
              className="f-TitleTab f-TitleTab-pink"
            />
          </div>
        )}
        <div className="f-sectioncardarticles-articles-content-mg">
          {props.itemsFilter.length === 0 && (
            <p className="f-element-not-found">
              {" "}
              Se encontraron 0 resultados para "
              {props.valueSerched !== "" ? props.valueSerched : "Tu búsqueda"}"
            </p>
          )}
          {props.itemsFilter.map((info, index) => {
            if (index < props.numArticles) {
              if (
                index % 3 === 0 &&
                index > 0 &&
                props.activeCategory !== "articulos-usuarias"
              ) {
                if ((index / 3) % 2 === 0) {
                  return (
                    <Fragment key={index}>
                      <FeaturedArticle
                        item={
                          props.featuredArticles[
                            (index / 6 - 1) % props.featuredArticles.length
                          ]
                        }
                        setModalState={props.setModalState}
                      />
                      <CardArticleMG
                        item={info}
                        indexItem={index + 1}
                        setModalState={props.setModalState}
                        localLikes={localLikes}
                        handleLike={handleLike}
                        handleUnLike={handleUnLike}
                        handleSave={handleSave}
                        handleUnSave={handleUnSave}
                        savedArticles={savedArticles}
                        categoryFilterTitleActive={categoryFilterTitleActive}
                      />
                    </Fragment>
                  )
                } else {
                  return (
                    <Fragment key={index}>
                      <FeaturedAutopauta
                        mobile={props.mobile}
                        item={
                          props.autoPautaGrid[
                            ((index / 3 - 1) / 2) % props.autoPautaGrid.length
                          ]
                        }
                      />
                      <CardArticleMG
                        item={info}
                        indexItem={index + 1}
                        setModalState={props.setModalState}
                        localLikes={localLikes}
                        handleLike={handleLike}
                        handleUnLike={handleUnLike}
                        handleSave={handleSave}
                        handleUnSave={handleUnSave}
                        savedArticles={savedArticles}
                        categoryFilterTitleActive={categoryFilterTitleActive}
                      />
                    </Fragment>
                  )
                }
              } else {
                return (
                  <CardArticleMG
                    item={info}
                    key={index}
                    indexItem={index + 1}
                    setModalState={props.setModalState}
                    localLikes={localLikes}
                    handleLike={handleLike}
                    handleUnLike={handleUnLike}
                    handleSave={handleSave}
                    handleUnSave={handleUnSave}
                    savedArticles={savedArticles}
                    categoryFilterTitleActive={categoryFilterTitleActive}
                  />
                )
              }
            }

            return null
          })}
        </div>
        {props.itemsFilter.length > props.numArticles && (
          <p
            className="f-sectioncardarticles-articles-content-mg-more"
            onClick={() =>
              props.setnumArticles(props.numArticles + props.articleBase)
            }
          >
            Cargar más
          </p>
        )}
      </div>
    </div>
  )
}

export default SectionCardArticlesMG
